import React, { useEffect, useState } from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  DateInput,
  Labeled,
  ReferenceInput,
} from "react-admin";
import axios from "axios";
import { hostname } from "../../providers/api";
import { useTokenOps } from "../../components/TokenContext";
import { REFERENCE_TYPES, PROJECT_FUNCTIONAL_UNITS, _STATUS } from "../../consts";

const bcomeVersionOptionText = (record) => {
  if (!record) return "";
  const lca = record.lcaMethodologyVersion?.name || "";
  const db = record.databaseVersion?.name || "";
  return `${lca} - ${db}`;
};

const CreateProject = (props) => {
  const tokenOps = useTokenOps();
  const [activeBcomeVersionId, setActiveBcomeVersionId] = useState(null);

  useEffect(() => {
    axios
      .get(`${hostname}/bcome-version`, {
        params: { filter: "isActive||$eq||true", limit: 1 },
        headers: {
          "Content-type": "application/json",
          authorization: "Bearer " + tokenOps.account?.accessToken,
        },
      })
      .then(({ data }) => {
        const list = Array.isArray(data) ? data : data?.data;
        if (list && list[0]) setActiveBcomeVersionId(list[0].id);
      })
      .catch((error) => console.log(error));
  }, [tokenOps.account]);

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <SelectInput source="referenceType" choices={REFERENCE_TYPES} label="References type" />
        <SelectInput source="functionalUnit" choices={PROJECT_FUNCTIONAL_UNITS} label="Functional unit" />

        {/* Version is read-only: it defaults to the active version and can only
            be changed later via the version selector in the project upload flow
            (see ProjectShow Calculation tab). */}
        <ReferenceInput
          label="Version"
          source="bcomeVersionId"
          reference="bcomeVersion"
          sort={{ field: "databaseVersionId", order: "ASC" }}
          perPage={100}
          defaultValue={activeBcomeVersionId}
        >
          <SelectInput optionText={bcomeVersionOptionText} disabled />
        </ReferenceInput>

        <BooleanInput source="supplyMapDigitalization" defaultValue={true} />

        <BooleanInput label="Km from origin to warehouse" source="originWarehouseKm" defaultValue={true} />

        <Labeled label="Data collection"></Labeled>
        <TextInput source="dataCollectionURL" label="Data collection url" required={false} />
        <TextInput source="folderURL" label="Folder url" required={false} />
        <SelectInput source="status" choices={_STATUS} label="Status" />
        <DateInput source="closingDate" required={false} />
      </SimpleForm>
    </Create>
  );
};

export default CreateProject;
